import axios from 'axios';

export default function setAuthorizationHeader(token: string): void {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}
